import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
   apiKey: "AIzaSyBpy3HlQKNAqXglFtXoUMpswXLUzKlIjAQ",
  authDomain: "pratikbar-a756f.firebaseapp.com",
  projectId: "pratikbar-a756f",
  storageBucket: "pratikbar-a756f.firebasestorage.app",
  messagingSenderId: "140375632286",
  appId: "1:140375632286:web:68c038419a1cbc4ba3ce8f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth  = getAuth();
export const db  = getFirestore(app);
export default app;